import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import DashboardView from "@/components/dashboard/dashboard-view";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";

// `d`: dashboard de empresa elegido en el selector (sin `d` = el ultimo usado).
// `w`: widget IoT abierto en el panel de configuracion (enlace directo).
const searchSchema = z.object({
  d: z.string().optional(),
  w: z.string().optional(),
});

export const Route = createFileRoute("/_authenticated/dashboard")({
  validateSearch: searchSchema,
  component: DashboardPage,
});

function DashboardPage() {
  const { d, w } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  return (
    <RouteGuardPermissions
      permissions={[{ module: "dashboard", actions: ["read"] }]}
    >
      <DashboardView
        dashboardId={d}
        onDashboardChange={(id) =>
          void navigate({ search: id ? { d: id } : {}, replace: true })
        }
        widgetId={w ?? ""}
        onWidgetChange={(id) =>
          void navigate({ search: (prev) => ({ ...prev, w: id ?? undefined }), replace: true })
        }
      />
    </RouteGuardPermissions>
  );
}
